export class WorkOrderCommentTag {
    taggedUserEmail: string;

    taggedUserName: string;
}